import { IHttpApi } from '@cian/http-api';
import { IConfig } from '@cian/config/shared';

import { IGetChartRequestParams, getChart } from './getChart';
import { EDataType } from '../../types/share';

export interface IUpdateAllCharts {
  httpApi: IHttpApi;
  config: IConfig;
  params: Omit<IGetChartRequestParams, 'dataType'>;
}

export function getAllCharts({ httpApi, config, params }: IUpdateAllCharts) {
  return Promise.all([
    getChart({
      httpApi,
      config,
      parameters: { ...params, dataType: EDataType.Prices },
    }),
    getChart({
      httpApi,
      config,
      parameters: { ...params, dataType: EDataType.Demand },
    }),
    getChart({
      httpApi,
      config,
      parameters: { ...params, dataType: EDataType.Supply },
    }),
    getChart({
      httpApi,
      config,
      parameters: { ...params, dataType: EDataType.MortgageRate },
    }),
  ]);
}
